import React from 'react';
import { authService } from '../../services/auth';
import BriqqLogo from '../brand/briqq-logo';
import styles from './dashboard-topbar.module.css';

const DashboardTopBar: React.FC = () => {

  const handleSignOut = () => {
    authService.signOut();
    // Force a page reload to ensure clean state
    window.location.href = '/';
  };

  return (
    <div className={styles.topBar}>
      <div className={styles.topBarContent}>
        <div className={styles.logoContainer}>
          <BriqqLogo size="medium" showBeta={true} />
        </div>
        <button onClick={handleSignOut} className={styles.signOutButton}>
          Sign Out
        </button>
      </div>
    </div>
  );
};

export default DashboardTopBar; 